import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Chip, Stack, alpha } from '@mui/material';
import { TitleTypes } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import ConstraintMenu from './constraint-menu';

interface Props {
  label: string;
  titleType?: string;
  exclude?: boolean;
  disabled?: boolean;

  handleExcludeChange?(value: boolean): () => void;

  handleRemoveRecruiterConstraint(): void;
}

const ConstraintChip: React.FC<Props> = ({ label, titleType, exclude, disabled, handleExcludeChange, handleRemoveRecruiterConstraint }) => {
  const { classes, cx } = useStyles();

  const [anchorEl, setAnchorEl] = useState<any | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = (el: any) => {
    setMenuOpen(true);
    setAnchorEl(el);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      <Chip
        className={cx(classes.chip, exclude ? 'exclude' : undefined)}
        variant={'outlined'}
        size={'small'}
        label={
          !_.isNil(titleType) ? (
            <Stack direction={'row'} alignItems={'center'} gap={0.5}>
              {titleType === TitleTypes.OCCUPATION ? <FormatListBulletedIcon className={classes.icon} /> : null} {label}
            </Stack>
          ) : (
            label
          )
        }
        onDelete={handleRemoveRecruiterConstraint}
        onClick={!_.isNil(handleExcludeChange) && !_.isNil(exclude) ? (event: React.MouseEvent) => handleOpenMenu(event.target) : undefined}
        disabled={disabled}
      />

      {!_.isNil(handleExcludeChange) && !_.isNil(exclude) ? (
        <ConstraintMenu
          anchorEl={anchorEl}
          menuOpen={menuOpen}
          exclude={exclude}
          handleExcludeChange={handleExcludeChange}
          handleCloseMenu={handleCloseMenu}
        />
      ) : null}
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderColor: theme.palette.greys.light,
    borderRadius: '6px',
    backgroundColor: '#FFF',
    '&.exclude': {
      background: alpha(theme.palette.error.main, 0.2),
      borderColor: theme.palette.error.main,
      '& .MuiSvgIcon-root': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root:hover': {
      color: theme.palette.secondary.main,
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
  },
}));

export default ConstraintChip;
